import { CoinCommon } from '../types';
/*
  @params ['a', 'b', 'c', 'd'] 2
  @return ['a', 'b', 'd']
*/
export const mergeForSlice = (arr: any[], index: number) => {
  let front = arr.slice(0, index);
  let back = arr.slice(index + 1, arr.length);
  return front.concat(back);
}

/* 
  @params ['a', 'b', 'c', 'd'] 
  @return {a: 0, b: 1, c: 2, d:3}
*/
export const arrToObj = (arr: any[]) => arr.reduce((acc, cur, idx) => {
  acc[cur] = idx
  return acc
}, {});

export function latestTicker<T>(datas: T[], parse: Function): CoinCommon[] {
  const sortedObj: any = {};
  datas.forEach((data: T) => {
    let commonData = parse(data);
    if (sortedObj[commonData.code]) {
      // 버퍼에 있는 데이터중 시간이 가장 최근인 데이터만 남김
      sortedObj[commonData.code] =
        sortedObj[commonData.code].timestamp > commonData.timestamp
          ? sortedObj[commonData.code]
          : commonData
    } else {
      sortedObj[commonData.code] = commonData; // 새로운 데이터면 그냥 넣음
    }
  });

  const sortedData = Object.keys(sortedObj).map(
    (data) => sortedObj[data]
  );

  return sortedData.sort((a, b) => a.volume - b.volume ? 1 : -1)
}